import * as ActionTypes from 'actions';

const initialState = {
  message: '',
  visible: false,
  status: null,
};

export default function(state = initialState, action = {}) {
  const { type, error, message } = action;

  switch (type) {
  case ActionTypes.REMOVE_ERROR_MESSAGE:
    return Object.assign({}, state, { status: null, visible: false });

  case ActionTypes.SET_ERROR_MESSAGE:
    return Object.assign({}, state, {
      status: 400,
      message,
      visible: true,
    });

  case ActionTypes.LOGIN_FAILURE:
  case ActionTypes.LOGIN_VALIDATE_FAILURE:
  case ActionTypes.ACTIVATE_FAILURE:
  case ActionTypes.SETUP_FAILURE:
  case ActionTypes.CONVERT_FAILURE:
  case ActionTypes.SIGNUP_FAILURE:
  case ActionTypes.EVENTS_FAILURE:
  case ActionTypes.SINGLE_EVENT_FAILURE:
  case ActionTypes.INBOX_FAILURE:
  case ActionTypes.SCHEDULE_LIST_FAILURE:
  case ActionTypes.SCHEDULE_VIEW_FAILURE:
  case ActionTypes.PAGE_LIST_FAILURE:
  case ActionTypes.PAGE_VIEW_FAILURE: {
    const errorMessage = error.error_msgs ? error.error_msgs.join('. ') : error.message;
    return Object.assign({}, state, {
      status: error.status,
      message: errorMessage,
      visible: true,
    });
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/errorState.js